import * as angular from 'angular';

import { VideoService } from '../services/video-service';

interface IVideoScope extends angular.IScope {
    title: string;
    src: string;
    playVideo: (title: string, src: string) => void;
}

export class VideoController implements angular.IController {
    static readonly $inject = ['$scope', 'fcVideoService'];

    private readonly videosModal: JQuery;
    private readonly playerModal: JQuery;

    constructor(private readonly scope: IVideoScope, private readonly videoService: VideoService) {
        this.scope.playVideo = this.playVideo.bind(this);

        // Listen for external video play requests (and destroy as required)
        const subscription = this.videoService.play$.subscribe(video =>
            this.playVideo(video.title, video.src)
        );

        this.scope.$on('$destroy', () => subscription.unsubscribe());

        // Listen for the video modal closing
        this.videosModal = angular.element('#fc-videos-modal');
        this.playerModal = angular.element('#fc-video-player-modal');

        this.playerModal.on('closed.zf.reveal', () => {
            const player = angular.element('#fc-video-player');
            const element = player[0] as HTMLVideoElement;

            // Pause the video
            element.pause();

            // And clear the source
            player.prop('src', '');
        });
    }

    private playVideo(title: string, src: string): void {
        this.scope.title = title;
        this.scope.src = src;

        // Manual open/close the modal
        // Auto open/close fails for IE
        this.videosModal.foundation('close');
        this.playerModal.foundation('open');
    }
}
